var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlFilledFifteen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4517_382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8721 25.0351C9.9201 24.4891 9.27686 23.4632 9.27686 22.2891C9.27686 17.4427 13.2196 13.5 18.0659 13.5H21.6878L21.8584 10.6875H1.33594L2.81003 35.009C2.84381 35.5658 3.30496 36 3.86279 36H10.3343C9.67072 35.1181 9.27686 34.0222 9.27686 32.8359C9.27686 31.4684 10.1492 30.3008 11.3665 29.86C10.935 29.1984 10.6831 28.4095 10.6831 27.5625C10.6831 26.7146 10.9355 25.925 11.3678 25.2628C11.024 25.1853 10.8331 25.1093 10.8721 25.0351Z",
    fill: "#D2AE5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6005 8.5784C11.6013 8.5784 11.6021 8.57812 11.6029 8.57812H22.1484C22.731 8.57812 23.2031 8.10599 23.2031 7.52344C23.2031 6.94089 22.731 6.46875 22.1484 6.46875H13.5486L16.3916 2.10937H20.0391C20.6216 2.10937 21.0937 1.63724 21.0937 1.05469C21.0937 0.472137 20.6216 0 20.0391 0H15.8203C15.4638 0 15.1315 0.179901 14.937 0.478455L11.0303 6.46875H1.05469C0.472137 6.46875 0 6.94089 0 7.52344C0 8.10599 0.472137 8.57812 1.05469 8.57812H11.5966C11.598 8.57812 11.5994 8.5784 11.6005 8.5784Z",
    fill: "#D2AE5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3906 22.2891C11.3906 22.8716 11.8628 23.3438 12.4453 23.3438H34.9453C35.5279 23.3438 36 22.8716 36 22.2891C36 18.6059 33.0035 15.6094 29.3203 15.6094H18.0703C14.3871 15.6094 11.3906 18.6059 11.3906 22.2891Z",
    fill: "#D2AE5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9062 25.4531C13.7411 25.4531 12.7969 26.3974 12.7969 27.5625C12.7969 28.7276 13.7411 29.6719 14.9062 29.6719H32.4844C33.6495 29.6719 34.5937 28.7276 34.5937 27.5625C34.5937 26.3974 33.6495 25.4531 32.4844 25.4531H14.9062Z",
    fill: "#D2AE5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9453 31.7812H12.4453C11.8628 31.7812 11.3906 32.2534 11.3906 32.8359C11.3906 34.5806 12.8101 36 14.5547 36H32.8359C34.5806 36 36 34.5806 36 32.8359C36 32.2534 35.5279 31.7812 34.9453 31.7812Z",
    fill: "#D2AE5F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4517_382"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlFilledFifteen);
export default __webpack_public_path__ + "static/media/al-filled-fifteen.455e2bcbdc399a5c3e9669d74a070bfe.svg";
export { ForwardRef as ReactComponent };